module.exports = __webpack_public_path__ + "img/section1MBg.21ceb180.webp";